import { render, staticRenderFns } from "./MetadataRepresentation.vue?vue&type=template&id=712a31b3&scoped=true&"
import script from "./MetadataRepresentation.vue?vue&type=script&lang=js&"
export * from "./MetadataRepresentation.vue?vue&type=script&lang=js&"
import style0 from "./MetadataRepresentation.vue?vue&type=style&index=0&id=712a31b3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712a31b3",
  null
  
)

export default component.exports